// import classNames from 'classnames'
import classNames from 'classnames'
// import {useState} from 'react'
import {render} from 'storyblok-rich-text-react-renderer'

import {Circles} from '@/assets/specify'
import {componentTypes} from '@/common/enums'
import {TGridCardsV2} from '@/common/types'
import {unwrapRenderParagraph} from '@/common/utils'
import BoxShadow from '@/components/BoxShadow'
import ButtonStoryblok from '@/components/ButtonStoryblok'
import ButtonTertiary from '@/components/ButtonTertiary'
import masonryCardStyles from '@/components/MasonryCard/MasonryCard.module.scss'
import StoryblokImage from '@/components/StoryblokImage/StoryblokImage'

import styles from './GridCardsV2.module.scss'

const GridCardsV2 = ({heading, paragraph, button = [], cards = []}: TGridCardsV2): JSX.Element => {
  // const [active, setActive] = useState<number>()

  return (
    <section className={styles.section}>
      <div className={styles.content}>
        {heading && <h2 className={styles.heading}>{heading}</h2>}

        {paragraph && <p className={styles.paragraph}>{paragraph}</p>}

        {cards.length > 0 && (
          <div className={styles.logosContainer}>
            {/* {cards.map((props, index) => {
              if (props.component !== componentTypes.GRID_CARD) return null

              const {images = []} = props

              if (index !== active) return null

              return (
                <div
                  key={props._uid}
                  className={classNames(styles.logos, {[styles.isActive]: index === active})}
                >
                  {images.map((props) => {
                    if (props.component !== componentTypes.IMAGE) return null
                    return (
                      <Image
                        key={props._uid}
                        {...props}
                        wrapperClassName={styles.logoWrapper}
                        className={styles.logo}
                      />
                    )
                  })}
                </div>
              )
            })} */}
          </div>
        )}

        {button.map((props) => {
          if (props.component !== componentTypes.BUTTON_STORYBLOK) return null
          return (
            <div key={props._uid} className={styles.button}>
              <ButtonStoryblok {...props} theme='default' />
            </div>
          )
        })}
      </div>

      <div className={styles.circles}>
        <Circles className={styles.circlesSvg} />
      </div>

      <div className={styles.cards}>
        {cards.length > 0 &&
          cards.map((props) => {
            const {uuid, content} = props
            if (!content) return null
            const {
              component,
              image,
              title,
              paragraph,
              linkLabel,
              link,
              withShadow = true,
              fillHeight = true,
            } = content

            if (component !== componentTypes.GRID_CARD_CONTENT) return null

            return (
              <div
                key={uuid}
                className={styles.card}
                // onMouseEnter={() => setActive(index)}
              >
                <div
                  className={classNames(masonryCardStyles.wrapper, {
                    [masonryCardStyles.fillHeight]: fillHeight,
                  })}
                >
                  {link && <BoxShadow className={masonryCardStyles.shadow} />}
                  <div
                    className={classNames(masonryCardStyles.card, {
                      [masonryCardStyles.withShadow]: withShadow,
                    })}
                  >
                    {image && (
                      <StoryblokImage
                        src={image.filename}
                        alt={image.alt || ''}
                        loading='lazy'
                        className={masonryCardStyles.image}
                        sizes={{md: 50, lg: 20}}
                      />
                    )}
                    {title && <p className={masonryCardStyles.title}>{title}</p>}
                    {paragraph && (
                      <p
                        className={classNames(masonryCardStyles.paragraph, {
                          [masonryCardStyles.withTitle]: title,
                        })}
                      >
                        {render(paragraph, unwrapRenderParagraph)}
                      </p>
                    )}
                    {link && (
                      <div className={masonryCardStyles.linkWrapper}>
                        <ButtonTertiary
                          className={masonryCardStyles.link}
                          label={linkLabel}
                          link={link}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )
          })}
      </div>
    </section>
  )
}

export default GridCardsV2
